import { Box, Report, UserOutlined, Workflows } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import { AIGettingStartedButton } from "./getting-started-button/AIGettingStartedButton";
import { MagicWand } from "components/icons/MagicWand";
import { IBR_FEATURES } from "components/licenses/common";
import { AUTH_REPORT_VIEW, AUTH_WORKFLOW_CREATE, AUTH_WORKFLOW_VIEW } from "domain/authority";
import { toFeatureLicenseType } from "domain/users";
import { userSessionService } from "services/user/UserSessionService";

import testIds from "testIds.json";

interface Props {
    onSubmit: (query: string) => void;
}

interface Item {
    icon: React.ReactNode;
    text: string;
    testId: string;
}

export const AIGettingStartedPanel = (props: Props) => {
    const { t } = useTranslation();

    // TODO: Render buttons based on user's role and usage patterns instead of authorities.
    const hasWorkflowAuths = userSessionService.userHasAllAuthorities([AUTH_WORKFLOW_CREATE, AUTH_WORKFLOW_VIEW]);
    const hasReportAuths = userSessionService.userHasAllAuthorities([AUTH_REPORT_VIEW]);
    const userHasAnyWorkflowLicense = userSessionService.hasAnyFeatureLicense(IBR_FEATURES.map(toFeatureLicenseType));

    const items: Item[] = [
        {
            icon: <MagicWand color={"--app-aiPanel-iconColor"} />,
            text: "AiAgent.gettingStarted.chooseProduct",
            testId: testIds.workArea.aiPanel.gettingStartedPanel.chooseProductButton,
        },
        {
            icon: <Workflows color={"--app-aiPanel-iconColor"} />,
            testId:
                hasWorkflowAuths && userHasAnyWorkflowLicense
                    ? testIds.workArea.aiPanel.gettingStartedPanel.setUpWorkflowButton
                    : testIds.workArea.aiPanel.gettingStartedPanel.explainWorkflowsButton,
            text:
                hasWorkflowAuths && userHasAnyWorkflowLicense
                    ? "AiAgent.gettingStarted.setUpWorkflow"
                    : "AiAgent.gettingStarted.explainWorkflows",
        },
        {
            icon: <UserOutlined color={"--app-aiPanel-iconColor"} />,
            text: "AiAgent.gettingStarted.checkLicenseStatus",
            testId: testIds.workArea.aiPanel.gettingStartedPanel.checkLicenseStatusButton,
        },
        {
            icon: <Report color={"--app-aiPanel-iconColor"} />,
            text: hasReportAuths ? "AiAgent.gettingStarted.viewReports" : "AiAgent.gettingStarted.explainReports",
            testId: hasReportAuths
                ? testIds.workArea.aiPanel.gettingStartedPanel.viewReportsButton
                : testIds.workArea.aiPanel.gettingStartedPanel.explainReportsButton,
        },
    ];

    return (
        <Box
            flexWrap={"Wrap"}
            gap={"Sm"}
            horizontalAlignment="Center"
            testId={testIds.workArea.aiPanel.gettingStartedPanel.itself}
        >
            {items.map((item) => (
                <AIGettingStartedButton
                    key={item.testId}
                    onClick={() => props.onSubmit(t(item.text))}
                    testId={item.testId}
                    icon={item.icon}
                >
                    {t(item.text)}
                </AIGettingStartedButton>
            ))}
        </Box>
    );
};
